import { supabase } from "./supabase";

interface NotifyParams {
  recipientId: string;
  projectId?: string;
  type: string;
  title: string;
  message: string;
  link?: string;
  sendEmail?: boolean;
}

/**
 * Fire-and-forget notification helper. Calls the send-notification edge function.
 * Errors are logged but not re-thrown so they never break the caller's flow.
 */
export async function notify(params: NotifyParams): Promise<void> {
  try {
    const { error } = await supabase.functions.invoke("send-notification", {
      body: params,
    });
    if (error) {
      console.error("notify: edge function error", error);
    }
  } catch (err) {
    console.error("notify: unexpected error", err);
  }
}
